// removed by extract-text-webpack-plugin
module.exports = {"menuTitle":"_35xOS6lWAhWiQfM6QtFgBl","headerTitle":"_2TgaPdiHhFqHnsdbDfpYcv","headerPanelActions":"aC20r8yfaRD_Y7qeAUiWT","menuItem":"_2pB-tHj5Uk1FZ23TTVdaIn","actionsPanel":"_19kisnrgXiVsm-bCiblIRI","contentPanel":"_1GcuW-KT1xQYEIlIAChEcf","isActive":"EruVbOZ6mVQ4s0G5cvX6","AccountLandingPageBackButtonContainer":"qSJ8pjA9FToJbPzICl8CE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Account/LandingPage/LandingPage.css
// module id = 1512
// module chunks = 0